import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import ProfileForm from '../../auth/components/ProfileForm';
import Loader from '../../../components/Loader';
import { AuthAPI } from '../../../api';

const AccountAdmin = ({uuid}) => {
  const [profile, setProfile] = useState();
  const [loading, setLoading] = useState(true);

  React.useEffect(()=>{
    const fetchProfile = async(uuid) => {
      const resp = await AuthAPI.adminGetProfile(uuid);
      setProfile(resp.payload.profile);
      setLoading(false);
    };
    fetchProfile(uuid);
  }, [uuid]);

  if (!profile) return <Loader/>;

  return (
    <ProfileForm
      loading={loading}
      profile={profile}
      isAdmin={true}
      setProfile={setProfile}
    />
  );
};

AccountAdmin.propTypes = {
  uuid: PropTypes.string.isRequired,
};

export default AccountAdmin;
